import { render, staticRenderFns } from "./HiddenMessages.vue?vue&type=template&id=00a7fdf6&"
import script from "./HiddenMessages.vue?vue&type=script&lang=js&"
export * from "./HiddenMessages.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/@nuxt/webpack/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports